/**
 * Checks a datetime value in ms for desired format. By convention the value has to represent a date between now and 3
 * years ago (arbitrary; includes a buffer to not be too strict).
 *
 * @param {number} datetime - An integer representing a datetime value in ms.
 * @param {number} minDateTime - A minimum datetime value in ms that should be allowed.
 * @return {boolean} - Returns true, if the passed value has the expected structure.
 */
export const isValidDatetimeMs = (datetime, minDateTime = new Date().setFullYear(new Date().getFullYear() - 3)) => {
    const checkDatetime = Number.isInteger(datetime) ? datetime : parseInt(datetime)

    return checkDatetime >= minDateTime
}
